import type { StaticImport } from "next/dist/shared/lib/get-img-props"

import { YOUTUBE_URL_REGEX } from "@/modules/companies/client/components/Media/constants"
import youtubePlayIcon from "@/modules/companies/client/components/Media/images/youtube_play_icon.png"

import styles from "@/modules/companies/client/components/Media/Media.module.css"

type PlayIconProps = {
  className: string
  src: string | StaticImport
}

export const getPlayIconProps = (videoUrl: string): PlayIconProps => {
  const videoUrlMatch = videoUrl.match(YOUTUBE_URL_REGEX)
  if (videoUrlMatch) {
    return {
      className: styles.youtubePlayIcon,
      src: youtubePlayIcon,
    }
  }
  return {
    className: "",
    src: "",
  }
}
